// extracted by mini-css-extract-plugin
export var container = "Template-module--container--dveKe";
export var footer = "Template-module--footer--bjByn";
export var header = "Template-module--header--ili9k";
export var routes = "Template-module--routes--uLWA0";
export var routesFullScreen = "Template-module--routesFullScreen--xFPd-";